import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants, DocumentExtensionHandling, FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-sequence',
  templateUrl: './sequence.component.html',
  styleUrls: ['./sequence.component.scss']
})
export class SequenceComponent {
  private documentRequired: boolean = false; 
  private allowedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_FILE_EXTENSIONS ];
  private acceptedFileTypes = [ ...DocumentExtensionHandling.MS_WORD_ACCEPT_TYPE ];
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {
    this.determineDocumentRequired();
  }

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
          data: { 
            fileName: DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO,
            allowedFileTypes: this.allowedFileTypes,
            fileAcceptTypes: this.acceptedFileTypes
          }
        });
    dialogRef.afterClosed().subscribe();
  }

  get wasFileUploaded(): boolean {
    const fileName = DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO;
    if(!fileName) {
      return false;
    }

    return this.formService.doesCurrentFormHaveAttachmentForSection(fileName);
  }

  get attachments(): AttachmentModel[] {
    return this.formService.allAttachmentsForSection(DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO);
  }

  get title() {
    if(this.isFormAType) {
      return `Sequence and Structural information, Oligonucleotides and Short Peptides (MS-Word Document)`;
    }

    if(this.isFormDType) {
      return `All Proteins and peptides`;
    }

    return `Sequence and Structural information, All Proteins and Peptides (MS-Word Document)`;
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }
  
  get isFormAType(): boolean {
    return 'FormA' === this.formType;
  }

  get isFormBType(): boolean {
    return 'FormB' === this.formType;
  }

  get isFormCType(): boolean {
    return 'FormC' === this.formType;
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }

  get isFormEType(): boolean {
    return 'FormE' === this.formType;
  }

  get isFormFType(): boolean {
    return 'FormF' === this.formType;
  }

  get isDocumentRequired(): boolean {
    return this.documentRequired;
  }
  
  get showRequiredError(): boolean {
    return this.documentRequired && this.formService.isShowingErrorSections && !this.hasDocument;
  }

  private determineDocumentRequired() {
    this.documentRequired = FormRequiredDocumentsMapping.isDocumentRequiredForForm(this.formService.getCurrentUsanFormType(), DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO);
  }
  
  get hasDocument(): boolean {
      return this.formService.doesCurrentFormHaveAttachmentForSection(DocumentConstants.SEQUENCE_AND_STRUCTURAL_INFO);
  }
 
}
